import React from 'react'

import { Box } from 'component-library/compositions/Box/Box'
import { Gallery } from 'component-library/content/Gallery/Gallery'
import { GalleryPublicationProps } from '../SharedPublication.routing'
import { AdUnitWrapper } from 'component-library/advertising/AdUnit/AdUnitWrapper'

export const PerthNowGallery: React.FC<GalleryPublicationProps> = ({
    gallery,
    galleryMeta,
    onEvent,
    adState,
}) => {
    return (
        <Box verticalSpacing="md">
            <Gallery
                entitled={true}
                isPremium={gallery.isPremium}
                title={gallery.heading}
                images={gallery.images}
                adFrequency={3}
                publicationDate={gallery.publicationDate}
                profile={gallery.profile}
                byline={gallery.byline}
                source={gallery.source}
                ads={galleryMeta.galleryAds.map(ad => (
                    <AdUnitWrapper
                        hiddenUntilLoaded={ad.hiddenUntilLoaded}
                        noticePosition={ad.noticePosition}
                        padding={ad.padding}
                        adState={adState}
                        unitId={ad.slot.id}
                        onEvent={onEvent}
                    />
                ))}
                mainImage={gallery.heroImage}
                shareUrl={gallery._self}
                onEvent={onEvent}
            />
        </Box>
    )
}
